import React from "react";
import classNames from "classnames/dedupe";
import { IDropdownButtonTextProps, ISet } from "../Select";
import { extractCurrentPrice, Price } from "../../../DataDisplay/Price";

export function BundleButtonRender({
  classes,
  hasSelectedValue,
  placeholder,
  selected,
}: IDropdownButtonTextProps<ISet>): JSX.Element {
  if (!hasSelectedValue)
    return <div className="text-color-grey-600">{placeholder}</div>;

  const mainPrice = extractCurrentPrice(selected.prices);

  return (
    <div
      data-testid="BundleButtonRender"
      className={classNames(
        "d-flex align-items-center text-start min-w-0 lh-24",
        classes?.root,
      )}
    >
      <span
        title={selected.title}
        className="text-color-blue max-lines max-lines--2 me-4 me-lg-6"
        data-testid="BundleButtonRender__amount"
      >
        {selected.title}
      </span>
      <span className="white-space-nowrap text-color-blue font-weight-bold">
        <Price {...mainPrice} />
      </span>
    </div>
  );
}
